<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { Text, Alert, IconButton, Input, Slider } from '@Shelly/shelly-design-system';
	// Helpers
	import { addNumberStep } from 'src/helpers/number_input_helpers';
	import { capFirstChar, valueOutOfRange } from 'src/helpers/utilities';

	export let value;
	export let isValid = false;

	export let action;
	export let onChange;

	const min = !isNaN(action?.config?.min) ? action?.config?.min : -999999999999999;
	const max = !isNaN(action?.config?.max) ? action?.config?.max : 999999999999999;
	const unit = action?.config?.unit || '';
	const view = action?.config?.view;

	// Use configured step value if available; default to 1.
	// Note: The XT1 Water Valve position component typically uses step = 10.
	const step = action?.config?.step || 1;
	const title = capFirstChar(
		action?.title ||
			$format('title_scene_set_property_value', {
				default: 'Set {property} to',
				values: { property: action?.name },
			}),
	);

	let inputError: string = ''; // User input validation error

	$: input_val = typeof value !== 'undefined' ? value : action?.config?.default_value || 0;
	$: isValid = view === 'slider' || validateInput(input_val);

	/**
	 * Handle user input chage
	 * @param {string} val
	 */
	const handleChange = (val: number) => {
		input_val = val;
		onChange(val);
	};

	/**
	 * Validate user input and set error message if input is invalid
	 * @param {string} value
	 * @returns {bool} - true if input is valid
	 */
	const validateInput = (value: string): boolean => {
		inputError = '';
		if (isNaN(Number(value)) || value === '') {
			inputError = $format('scene_invalid_format_err_toast', {
				default: 'Invalid format. Please, fill out fields properly.',
			});
			return false;
		}
		if (valueOutOfRange(Number(value), min, max)) {
			inputError = $format('min_max_error_description', {
				values: {
					min,
					max,
				},
				default: 'Value must be between {min} and {max}.',
			});
			return false;
		}

		return true;
	};
	const a11yProps = {
		ariaLabel: $format('label_adjust_value', { default: 'Adjust value' }),
		ariaLabelValue: null,
	};
</script>

{#if view === 'slider'}
	<div class="mt-l">
		{#if action?.alert}
			<Alert class="mb-s" heading={action?.alert} type={'warning'} />
		{/if}
		<Slider
			id="slider-rmdanbg"
			{a11yProps}
			type="simple"
			value={input_val}
			{title}
			{min}
			{max}
			{step}
			{unit}
			on:value_change={(e) => handleChange(e.detail.value)}
		/>
	</div>
{:else}
	<Text element="h2" class="mb-s mt-l">{title}</Text>
	{#if action?.alert}
		<Alert class="mb-s" heading={action?.alert} type={'warning'} />
	{/if}

	<div class="d-flex mt-s">
		<IconButton
			aria-label={$format('button_decrease_value', { default: 'Decrease value' })}
			icon="fas fa-minus"
			on:click={() => {
				handleChange(addNumberStep(+input_val, -step));
			}}
			disabled={+input_val <= min}
		/>
		<Input
			aria-label={$format('input_value', { default: 'Value' })}
			class="width-md-m width-sm-full ml-s mr-s"
			size="m"
			icon={action?.icon}
			type="number"
			value={input_val}
			error={inputError}
			on:input={(e) => handleChange(e.target['value'])}
			id="input-yayoqyq"
		/>
		<IconButton
			aria-label={$format('button_increase_value', { default: 'Increase value' })}
			icon="fas fa-plus"
			on:click={() => {
				handleChange(addNumberStep(+input_val, step));
			}}
			disabled={+input_val >= max}
		/>
	</div>
{/if}
